import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { DownLoadFileService } from 'app/services/download-file.service';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { AnnualDeclaration } from '../model/annual-declaration.model';
import { MandatedIdentification } from '../model/mandatedIdentification.model';

@Injectable({
  providedIn: 'root',
})
export class AnnualDeclarationCommandApiService implements OnDestroy {

  private COMMAND_API = environment.legalEntityCommandApi;

  private destroy$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private downLoadFileService: DownLoadFileService,
  ) { }

  initAnnualDeclarationForm(legalEntityId: string, year: number): Observable<any> {
    const url = `${this.COMMAND_API}/legalentity/${legalEntityId}/Form/initAnnualDeclaration`;
    return this.http.post<any>(url, {year});
  }

  completeAnnualDeclarationForm(legalEntityId: string, paymentConfirmation: any, formData: AnnualDeclaration, mandatedIdentification: MandatedIdentification, year: number) {
    const url = `${this.COMMAND_API}/legalentity/${legalEntityId}/Form/completeAnnualDeclaration`;
    return this.http.post<any>(url, { paymentConfirmation, formData, mandatedIdentification, year });
  }

  uploadDocument(legalEntityId: string, type: string, file: File, year: number): Observable<void> {
    const data = new FormData();
    data.append('type', type);
    data.append('year', year?.toString());
    data.append('file', file);
    return this.http.post<any>(`${this.COMMAND_API}/legalentity/${legalEntityId}/uploadannualformattachment`, data);
  }

  authorizeDocumentDownload(legalEntityId: string, documentId: string, fileName: string): Observable<string> {
    return this.http.post<any>(`${this.COMMAND_API}/legalentity/${legalEntityId}/documents/${documentId}/authorizedownload`, {})
      .pipe(
        switchMap((res: { location: string }) => this.downLoadFileService.downloadFile(res.location, fileName)),
      );
  }

  deleteDocument(legalEntityId: string, documentId: string, year: number): Observable<any> {
    return this.http.post<any>(`${this.COMMAND_API}/legalentity/${legalEntityId}/documents/${year}/${documentId}/deleteannualformattachment`, {});
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
